import {lazy} from 'react';

export const BoxFilterContainerLazy = lazy(() => import(/* webpackChunkName: "boxFilterContainer" */ '.'));
